import React, { useContext } from "react";
import "./Permission_Pogout_Modal.css";
import { Button, Modal } from "react-bootstrap";
import LogoutModal from "../LogoutModal/LogoutModal";
import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import Success_Modal_2 from "../success_modal2/Success_Modal_2";
import { useNavigate } from "react-router-dom";

function Permission_Pogout_Modal(props) {
  const { setSignin } = useContext(Context);

  const [modalShow, setModalShow] = React.useState(false);

  const nevigate = useNavigate();
  const handleLogoutModal = async () => {
    try {
      Cookies.remove("local_mandai_security", { path: "/" });
      setSignin(false);
      setModalShow(true);
      props.onHide(true);
      setTimeout(() => {
        setModalShow(false);
        nevigate("/")
      }, 3000);
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  return (
    <>
      <div className=" Successfull_Modal_sec">
        <Modal
          className="Permission_Pogout_Modal Successfull_Modal"
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <p>Do You Want To Logout?</p>
            <div className="btn-holder">
              <Button className="yes-btn" onClick={handleLogoutModal}>
                Yes
              </Button>
              <Button className="no-btn" onClick={props.onHide}>
                No
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      {/* <LogoutModal show={modalShow} onHide={() => setModalShow(false)} /> */}

      <Success_Modal_2
        successText="Logout SuccessFully...!"
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

    

    </>
  );
}

export default Permission_Pogout_Modal;
